import { useCallback } from 'react';
import { useSearchParams } from 'react-router';

/**
 * Manages the `openReport` search-param selection for a single sitrep card.
 *
 * Encapsulates URL query param wiring plus some useful derived booleans that
 * indicate whether there is any selection and whether it matches the current
 * sitrep or card item.
 */
const useOpenReportSelection = (sitrepId: UUID, itemId: UUID) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const openReport = searchParams.get('openReport');

  const setOpenReport = useCallback(
    (newOpenReport: string) => {
      if (openReport === newOpenReport) return;
      setSearchParams(
        (prev) => {
          prev.set('openReport', newOpenReport);
          return prev;
        },
        { replace: true }
      );
    },
    [openReport, setSearchParams]
  );

  const hasOpenReportSelection = Boolean(openReport);
  const isOpenReportMatch = openReport === sitrepId || openReport === itemId;

  return {
    openReport,
    hasOpenReportSelection,
    isOpenReportMatch,
    setOpenReport,
  } as const;
};

export default useOpenReportSelection;
